export const upworkPaymentTypes = ['fixed Price', 'hourly']

export const hubstaffPaymentTypes = ['hourly', 'monthly', 'fixed price']
